import ReactMarkdown from "react-markdown";
import { ContentBlock } from "../backend";
import ExerciseBlock from "./ExerciseBlock";

interface BlockRendererProps {
  block: ContentBlock;
  courseId: number;
}

export default function BlockRenderer({ block, courseId }: BlockRendererProps) {
  if (block.type === "markdown") {
    // Cast to any or specific type that has content
    const content = (block as any).content;
    return (
      <div className="prose prose-lg max-w-none text-gray-700 my-6">
        <ReactMarkdown>{content as string}</ReactMarkdown>
      </div>
    );
  }

  if (block.type === "video") {
    const content = (block as any).content;
    return (
      <div className="aspect-video w-full rounded-lg overflow-hidden my-8 bg-black">
        <iframe
          src={content as string}
          className="w-full h-full"
          allowFullScreen
          title="Lesson Video"
        />
      </div>
    );
  }

  if (block.type === "exercise_ref") {
    // The backend expands `exercise_data` into the block
    const exerciseData = (block as any).exercise_data;
    if (!exerciseData) return null;

    return <ExerciseBlock exercise={exerciseData} courseId={courseId} />;
  }

  return null;
}
